import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class ChangeDate {
  /**
   * 1週間分の情報を取得する
   * @param {string} lgCd 市町村コード
   * @param {string} start 開始日
   * @param {number} rsvSetId 予約設定ID
   * @param {string} lastDateOfPrevCalender 前月のカレンダー最終日
   * @param {string} prevCalcedRsvStartDate 前月分でのオフセット考慮した予約開始日
   * @return {Promise<Array>} 1週間分の情報
   */
  getCalendarData = async (lgCd, start, bookingDate, rsvSetId, lastDateOfPrevCalender, prevCalcedRsvStartDate) => {
    const result = await requestManager.get(`${API_PATH}/changedate/r/`, {
      lgCd,
      start,
      bookingDate,
      rsvSetId,
      lastDateOfPrevCalender,
      prevCalcedRsvStartDate
    });
    // const result = await requestManager.post(`${API_PATH}/selectdate/r`, { lgCd, start });
    return result.data;
  };
}

export default new ChangeDate();
